import type { PopScreenVO } from "@/utils/hooks/useResourceFloat";
import Track from "@/utils/track";
import useNavigation from "@/utils/useNavigate";
import { Mask } from "antd-mobile";
import React, { useCallback, useEffect, useRef, useState } from "react";
import styles from "./index.module.less";

interface Props {
  data?: PopScreenVO;
  trackData?: Record<string, any>;
  onClose?: () => void;
}

const ResourceAdPopup: React.FC<Props> = ({ data, trackData, onClose }) => {
  const [visible, setVisible] = useState(true);
  const { navigateForResourceFloat } = useNavigation();
  const track = Track();

  const handleTrack = useCallback(
    (eventName: string, extra?: any) => {
      if (!trackData || !extra?.tracking_plan_id) {
        return;
      }
      const params = { ...trackData, ...extra, tracking_plan_ids: null };
      console.log("ResourceAdPopup track:", eventName, params);
      track.track(eventName, params);
    },
    [trackData, track],
  );

  // 曝光标记，确保只曝光一次
  const hasExposedRef = useRef(false);

  useEffect(() => {
    // 等待图片和埋点数据都准备好
    if (!data?.imgUrl) {
      return;
    }
    // 如果是商品详情，必须有spu_id才能曝光
    if (trackData?.resource_name === "商详弹窗" && !trackData?.spu_id) {
      return;
    }
    // 如果是档期页弹窗，必须有activity_id才能曝光
    if (trackData?.resource_name === "档期页弹窗" && !trackData?.activity_id) {
      return;
    }
    // 已曝光则跳过
    if (hasExposedRef.current) {
      return;
    }
    hasExposedRef.current = true;
    handleTrack("resource_expose", {
      tracking_plan_id: trackData?.tracking_plan_ids?.expose,
    });
  }, [data?.imgUrl, trackData]);

  // 没有数据时不渲染
  if (!data?.imgUrl) {
    return null;
  }

  const handleClose = () => {
    setVisible(false);
    onClose?.();
    handleTrack("resource_click", {
      tracking_plan_id: trackData?.tracking_plan_ids?.close,
      btn_name: "关闭",
    });
  };

  const handleClick = () => {
    // 根据 jumpType 处理跳转逻辑
    if (data.jumpType && data.jumpType !== "NOTHING") {
      navigateForResourceFloat(data.jumpType, data.jumpTarget);
      setVisible(false);
    }
    handleTrack("resource_click", {
      tracking_plan_id: trackData?.tracking_plan_ids?.click,
      btn_name: "查看详情",
    });
  };

  return (
    <Mask visible={visible} onMaskClick={handleClose} opacity={0.75}>
      <div className={styles.wrap}>
        <img className={styles.popupImg} src={data.imgUrl} alt="" onClick={handleClick} />
        <div className={styles.closeBtn} onClick={handleClose}>
          <img
            className={styles.closeIcon}
            src="https://akim-oss.aikucun.com/f1b739aab1d8afaf3cf03b6e5edf883ae10b3eac_1763605650170_6.png"
            alt=""
          />
        </div>
      </div>
    </Mask>
  );
};

export default ResourceAdPopup;
